
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_20116_100517)","fill":"#3DAFB8"}},[_c('path',{attrs:{"d":"M8.067 9.07A10.766 10.766 0 015.142 7.38c.418-.471.746-.93.999-1.342.59-.96.877-1.81 1.009-2.31h1.134V2.279H4.868V1.41H3.415v.867H0V3.73h5.634a7.577 7.577 0 01-.768 1.61 8.395 8.395 0 01-.785 1.055 8.935 8.935 0 01-1.073-1.382l-1.237.76c.26.422.667.998 1.265 1.633C2.209 8.082 1.232 8.638.11 9.07l.521 1.355c1.456-.56 2.588-1.278 3.466-2.023a12.24 12.24 0 003.447 2.023l.522-1.355zM12.167 5.492h-1.572L6.826 14.59h1.96l.889-2.234h3.412l.888 2.234H16l-3.833-9.097zm-1.817 5.166l1.03-2.592 1.032 2.592H10.35z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_20116_100517"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 1.41)","d":"M0 0h16v13.178H0z"}})])])])
          )
        }
      }
    